import {completeHydration} from "./actions/actions";

const delay = (store) => {
  if(process.env.NODE_ENV !== 'test'){
    store.dispatch(completeHydration());
  }
  return true;
};

export default delay;


// WEBPACK FOOTER //
// ./src/delayRendering.js